var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLancha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cb20caaf95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 3.703125 L 18 3.703125 L 18 5 L 12 5 Z M 12 3.703125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d9ea756e2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 12 L 29.515625 12 L 29.515625 15 L 0.484375 15 Z M 0.484375 12 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "90f3ca139e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 21 L 29.515625 21 L 29.515625 25.476562 L 0.484375 25.476562 Z M 0.484375 21 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5511616dd5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 14 L 29.515625 14 L 29.515625 23 L 15 23 Z M 15 14 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6b6c1a116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 14 L 15 14 L 15 23 L 0.484375 23 Z M 0.484375 14 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb20caaf95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.691406 4.914062 L 17.308594 4.914062 C 17.402344 4.914062 17.480469 4.839844 17.480469 4.746094 L 17.480469 3.871094 C 17.480469 3.777344 17.402344 3.703125 17.308594 3.703125 L 12.691406 3.703125 C 12.597656 3.703125 12.519531 3.777344 12.519531 3.871094 L 12.519531 4.746094 C 12.519531 4.839844 12.597656 4.914062 12.691406 4.914062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9ea756e2c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 29.25 13.71875 L 27.613281 12.632812 C 27.128906 12.3125 26.5625 12.140625 25.980469 12.140625 L 25.21875 12.140625 C 25.105469 12.140625 4.894531 12.140625 4.78125 12.140625 L 4.019531 12.140625 C 3.4375 12.140625 2.871094 12.3125 2.386719 12.632812 L 0.75 13.71875 C 0.636719 13.796875 0.558594 13.90625 0.523438 14.03125 C 0.808594 14.03125 29.175781 14.03125 29.476562 14.03125 C 29.441406 13.90625 29.363281 13.796875 29.25 13.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#90f3ca139e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 15 23.441406 C 9.347656 20.882812 3.417969 21.980469 0.503906 24.496094 C 4.679688 22.804688 9.613281 22.871094 15 25.476562 C 20.386719 22.871094 25.320312 22.804688 29.496094 24.496094 C 26.582031 21.980469 20.652344 20.882812 15 23.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5511616dd5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 20.765625 19.425781 L 21.417969 17.636719 C 21.472656 17.480469 21.597656 17.355469 21.757812 17.304688 L 23.191406 16.8125 C 23.316406 16.769531 23.433594 16.902344 23.375 17.023438 L 22.570312 18.742188 C 22.507812 18.867188 22.40625 18.96875 22.277344 19.027344 L 20.976562 19.621094 C 20.851562 19.679688 20.71875 19.554688 20.765625 19.425781 Z M 25.3125 17.882812 L 25.90625 16.25 C 25.972656 16.058594 26.125 15.914062 26.316406 15.847656 L 27.753906 15.359375 C 27.847656 15.328125 27.925781 15.429688 27.875 15.515625 L 26.882812 17.066406 C 26.835938 17.140625 26.769531 17.203125 26.695312 17.25 L 25.449219 18 C 25.371094 18.042969 25.28125 17.96875 25.3125 17.882812 Z M 21.675781 21.617188 C 22.355469 21.617188 23.023438 21.660156 23.671875 21.746094 C 25.964844 19.363281 28.515625 15.773438 29.398438 14.5 C 29.421875 14.464844 29.441406 14.429688 29.453125 14.394531 L 15.367188 14.394531 L 15.226562 22.941406 C 17.277344 22.074219 19.496094 21.617188 21.675781 21.617188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e6b6c1a116)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 2.246094 15.359375 L 3.683594 15.847656 C 3.875 15.914062 4.027344 16.058594 4.09375 16.25 L 4.6875 17.882812 C 4.71875 17.96875 4.628906 18.042969 4.550781 18 L 3.304688 17.25 C 3.230469 17.203125 3.164062 17.140625 3.117188 17.066406 L 2.125 15.515625 C 2.074219 15.429688 2.15625 15.328125 2.246094 15.359375 Z M 6.808594 16.8125 L 8.242188 17.304688 C 8.402344 17.355469 8.527344 17.480469 8.582031 17.636719 L 9.234375 19.425781 C 9.28125 19.554688 9.148438 19.679688 9.023438 19.621094 L 7.722656 19.027344 C 7.59375 18.96875 7.492188 18.867188 7.429688 18.742188 L 6.625 17.023438 C 6.566406 16.902344 6.683594 16.769531 6.808594 16.8125 Z M 0.601562 14.5 C 1.484375 15.773438 4.035156 19.363281 6.328125 21.746094 C 6.976562 21.660156 7.644531 21.617188 8.324219 21.617188 C 10.503906 21.617188 12.722656 22.074219 14.773438 22.945312 L 14.632812 14.394531 L 0.546875 14.394531 C 0.558594 14.429688 0.578125 14.464844 0.601562 14.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 7.207031 8.148438 C 7.332031 7.945312 7.539062 7.808594 7.773438 7.769531 C 8.859375 7.59375 12.132812 7.113281 15 7.113281 C 17.867188 7.113281 21.140625 7.59375 22.226562 7.769531 C 22.460938 7.808594 22.667969 7.945312 22.792969 8.148438 L 24.996094 11.777344 L 25.433594 11.777344 L 23.109375 7.953125 C 22.921875 7.644531 22.636719 7.410156 22.296875 7.289062 C 19.996094 6.460938 17.21875 5.957031 15 5.957031 C 12.78125 5.957031 10.003906 6.460938 7.703125 7.289062 C 7.363281 7.410156 7.078125 7.644531 6.890625 7.953125 L 4.566406 11.777344 L 5.003906 11.777344 L 7.207031 8.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 15 5.59375 C 15.226562 5.59375 15.457031 5.597656 15.691406 5.609375 L 15.691406 5.28125 L 14.308594 5.28125 L 14.308594 5.609375 C 14.542969 5.597656 14.773438 5.59375 15 5.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.261719 4.96875 C 21.261719 4.46875 20.859375 4.0625 20.363281 4.0625 L 19.554688 4.0625 C 19.054688 4.0625 18.652344 4.46875 18.652344 4.96875 L 18.652344 5.949219 C 19.535156 6.109375 20.417969 6.320312 21.261719 6.570312 L 21.261719 4.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 11.347656 4.96875 C 11.347656 4.46875 10.945312 4.0625 10.445312 4.0625 L 9.636719 4.0625 C 9.140625 4.0625 8.738281 4.46875 8.738281 4.96875 L 8.738281 6.570312 C 9.582031 6.320312 10.464844 6.109375 11.347656 5.949219 L 11.347656 4.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLancha);
export default __webpack_public_path__ + "static/media/Lancha.4c21b5e200fd20882925ea688c12f96b.svg";
export { ForwardRef as ReactComponent };